import { EntityModel } from '@/interfaces'
import {
  ALL_LANGUAGES_QUERY,
  CREATE_LANGUAGE_MUTATION,
  DELETE_LANGUAGE_MUTATION,
  FORCE_DELETE_LANGUAGE_MUTATION,
  SINGLE_LANGUAGE_QUERY,
  UPDATE_LANGUAGE_MUTATION,
} from './graphql'

const languageModel: EntityModel = {
  name: 'language',
  namePlural: 'languages',
  uniqueName: 'language',
  uniqueNamePlural: 'languages',
  path: 'config/language',
  baseUrl: '/config/languages',
  translationPrefix: 'entities:language.',
  getDisplayName: (values: any) => {
    return values.name
  },
  gql: {
    getAll: ALL_LANGUAGES_QUERY,
    getSingle: SINGLE_LANGUAGE_QUERY,
    create: CREATE_LANGUAGE_MUTATION,
    update: UPDATE_LANGUAGE_MUTATION,
    delete: DELETE_LANGUAGE_MUTATION,
    forceDelete: FORCE_DELETE_LANGUAGE_MUTATION,
  },
  attributes: {
    name: {
      name: 'name',
      label: 'entities:language.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    slug: {
      name: 'slug',
      label: 'entities:language.attributes.slug.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default languageModel
